import React from "react";

import { ParsedClassroom } from "@examspark/types";

import CourseDocuments from "../course/CourseDocuments";

import ClassroomSidebarAssessments from "./ClassroomSidebarAssessments";
import ClassroomActivities from "./sidebar/ClassroomActivities";
import ClassroomPacing from "./sidebar/ClassroomPacing";

const ClassroomSide = (props: { classroom?: ParsedClassroom }) => {
  return (
    <>
      <CourseDocuments course={props.classroom?.course} />
      <ClassroomPacing classroom={props.classroom} />
      <ClassroomActivities
        classroom={props.classroom}
        unit={props.classroom?.unit}
      />
      <ClassroomSidebarAssessments unit={props.classroom?.unit} />
    </>
  );
};

export default ClassroomSide;
